import { SearchResultsContentDS } from '@src/components/blocks/search-results-content-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SearchResultsContentLegacy, type SearchResultsContentLegacyProps } from './search-results-content-legacy'

export type SearchResultsContentProps = SearchResultsContentLegacyProps

// NOTE: this switcher is currently only mounted from the legacy subtree
// (`search-results-legacy.tsx`), which itself only renders when the DS gate is OFF — so in
// practice the DS branch below does not fire today (the DS path reaches `SearchResultsContentDS`
// directly via `SearchResultsDS`). The branch is kept as defensive symmetry with the repo's
// switcher convention, so a future DS parent can mount this component unchanged.
export const SearchResultsContent = (props: SearchResultsContentProps) => {
  if (shouldUseDesignSystem()) {
    return (
      <SearchResultsContentDS
        productCards={props.productCards}
        searchQuery={props.searchQuery}
        onResetFilters={props.onResetFilters}
        selectedFilters={props.selectedFilters}
      />
    )
  }
  return <SearchResultsContentLegacy {...props} />
}
